import AxisConfigurationModal, {
    type AxisConfiguration,
} from 'components/molecules/PackArchitecture/AxisConfigurationModal';
import KpiAxisConfigurationModal, {
    type KpiAxisConfiguration,
} from 'components/molecules/PackArchitecture/KpiAxisConfigurationModal';
import type { KpiDataRange, KpiBinLabelAffixes } from 'components/molecules/PackArchitecture/kpiAxisConfiguration.utils';
import type { AxisGroupByControlsMeta } from 'components/molecules/PackArchitecture/axisGroupByControlsMeta.types';
import type { KpiAxisControlsMeta } from 'components/molecules/PackArchitecture/kpiAxisControlsMeta.types';
import type { PricePackArchitectureRequest } from 'hooks/ppa/useFetchPricePackArchitecture';

type AxisConfigSettingsModalsProps = {
    isDimensionAxis: boolean;
    isKpiAxis: boolean;
    isSettingsOpen: boolean;
    selectedLabel: string;
    xAxis: string;
    chartRequest: PricePackArchitectureRequest | null;
    apiTotalCount: number;
    groupByControlsMeta?: AxisGroupByControlsMeta | null;
    kpiControlsMeta?: KpiAxisControlsMeta | null;
    axisConfiguration?: AxisConfiguration;
    resolvedKpiAxisConfiguration: KpiAxisConfiguration;
    dataRange: KpiDataRange;
    kpiBinLabelAffixes?: KpiBinLabelAffixes;
    hideGroupRestAsOther?: boolean;
    whitespacePreviewRequest?: Record<string, unknown> | null;
    useWhitespacePreview?: boolean;
    whitespacePreviewAxisKind?: 'column' | 'row';
    onClose: () => void;
    onApplyAxisConfiguration: (config: AxisConfiguration) => void;
    onApplyKpiAxisConfiguration: (config: KpiAxisConfiguration) => void;
};

const AxisConfigSettingsModals = ({
    isDimensionAxis,
    isKpiAxis,
    isSettingsOpen,
    selectedLabel,
    xAxis,
    chartRequest,
    apiTotalCount,
    groupByControlsMeta,
    kpiControlsMeta,
    axisConfiguration,
    resolvedKpiAxisConfiguration,
    dataRange,
    kpiBinLabelAffixes,
    hideGroupRestAsOther = false,
    whitespacePreviewRequest = null,
    useWhitespacePreview = false,
    whitespacePreviewAxisKind = 'column',
    onClose,
    onApplyAxisConfiguration,
    onApplyKpiAxisConfiguration,
}: AxisConfigSettingsModalsProps) => {
    return (
        <>
            {isDimensionAxis ? (
                <AxisConfigurationModal
                    open={isSettingsOpen}
                    dimensionLabel={selectedLabel}
                    controlsMeta={groupByControlsMeta}
                    initialConfig={axisConfiguration}
                    chartRequest={chartRequest}
                    xAxis={xAxis}
                    apiTotalCount={apiTotalCount}
                    hideGroupRestAsOther={hideGroupRestAsOther}
                    whitespacePreviewRequest={whitespacePreviewRequest}
                    useWhitespacePreview={useWhitespacePreview}
                    whitespacePreviewAxisKind={whitespacePreviewAxisKind}
                    onClose={onClose}
                    onApply={onApplyAxisConfiguration}
                />
            ) : null}
            {isKpiAxis ? (
                <KpiAxisConfigurationModal
                    open={isSettingsOpen}
                    kpiLabel={selectedLabel}
                    controlsMeta={kpiControlsMeta}
                    initialConfig={resolvedKpiAxisConfiguration}
                    dataRange={dataRange}
                    binLabelAffixes={kpiBinLabelAffixes}
                    chartRequest={chartRequest}
                    whitespacePreviewRequest={whitespacePreviewRequest}
                    useWhitespacePreview={useWhitespacePreview}
                    onClose={onClose}
                    onApply={onApplyKpiAxisConfiguration}
                />
            ) : null}
        </>
    );
};

export default AxisConfigSettingsModals;
